import { Button, Grid, Paper, Typography } from "@mui/material";

import { formatArticleLocationSuggestionDifference } from "helpers/articleLocationSuggestions";
import {
  ArticleLocationMatchSuggestion,
  ArticleLocationSuggestionError,
} from "types";

type Props = {
  error: ArticleLocationSuggestionError;
  title: string;
  onUseSuggestion: (
    error: ArticleLocationSuggestionError,
    suggestion: ArticleLocationMatchSuggestion,
  ) => void;
};

export default function ArticleLocationSuggestionPanel({
  error,
  title,
  onUseSuggestion,
}: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 1 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      {error.suggestions.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No hay sugerencias disponibles.
        </Typography>
      ) : (
        error.suggestions.map((suggestion) => (
          <Grid
            container
            key={suggestion.article_location_id}
            alignItems="center"
            spacing={1}
            sx={{ mb: 1 }}
          >
            <Grid item xs>
              <Typography variant="body2">
                {suggestion.location_code} - Stock disponible:{" "}
                {suggestion.available_subtotal}
              </Typography>
              {suggestion.differences.length > 0 && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ whiteSpace: "pre-line" }}
                >
                  {[
                    "Diferencias detectadas:",
                    ...suggestion.differences.map(
                      (difference) =>
                        `- ${formatArticleLocationSuggestionDifference(difference)}`,
                    ),
                  ].join("\n")}
                </Typography>
              )}
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="contained"
                onClick={() => onUseSuggestion(error, suggestion)}
              >
                Usar stock
              </Button>
            </Grid>
          </Grid>
        ))
      )}
    </Paper>
  );
}
